import z from "zod";

/**
 * IncluirObraAreaServicosSchema
 */

export const IncluirObraAreaServicosSchema = z.object({
  areas: z.array(z.number(), { required_error: 'Este campo deve ser preenchido!' }).nonempty('Este campo deve ser preenchido!'),
  checklists: z.array(z.number(), { required_error: 'Este campo deve ser preenchido!' }).nonempty('Este campo deve ser preenchido!'),
});

/**
 * IncluirObraAreaServicosForm
 */

export type IncluirObraAreaServicosForm = z.infer<typeof IncluirObraAreaServicosSchema>;